module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-6-7bd7e7bdc5b5d2b5e155d7b22d94abbc.jpg";